import { render, staticRenderFns } from "./simulations.vue?vue&type=template&id=33f68036"
import script from "./simulations.vue?vue&type=script&lang=js"
export * from "./simulations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports